import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/rooms" className="brand-link">
            LW Assistant
          </Link>
        </div>
        
        <div className="nav-links">
          <Link 
            to="/rooms" 
            className={`nav-link ${isActive('/rooms') ? 'active' : ''}`}
          >
            🏛️ Rooms
          </Link>
          <Link 
            to="/stats" 
            className={`nav-link ${isActive('/stats') ? 'active' : ''}`}
          >
            📈 Stats
          </Link>
          <Link 
            to="/codex" 
            className={`nav-link ${isActive('/codex') ? 'active' : ''}`}
          >
            📖 Codex
          </Link>
        </div>

        <div className="nav-user">
          <span className="user-info">
            {user?.email}
          </span>
          <button 
            onClick={handleLogout}
            className="btn btn-secondary btn-sm"
          >
            ↗️ Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;